// Where the portal login may send an accountant once they are in: the accept
// page of a client's invitation, on the API host. Nothing else qualifies.
//
// An invitation's email links to that page, which asks a logged-out accountant
// to log in and passes it here as `next`. The login page hands it to the
// backend with the request for a login link, the emailed link carries it back,
// and the login lands on the accept page instead of the dashboard.
//
// The backend checks the same thing again (`clean_login_next` in
// backend/api/services/client_accountant.py) and rebuilds the value, so this is
// only the first of two gates: the path on this host, exactly one `token`, and
// no whitespace or control characters.

const ACCEPT_PATH = "/api/accountant/client-invites/accept";
const MAX_LENGTH = 1000;

/** `raw` if it is the accept page of an invitation, else null. */
export function safeLoginNext(raw: string | null | undefined): string | null {
  if (!raw || raw.length > MAX_LENGTH) return null;
  // Whitespace and control characters (C0 and DEL).
  for (const ch of raw) {
    const code = ch.charCodeAt(0);
    if (code <= 32 || code === 127 || /\s/.test(ch)) return null;
  }
  if (!raw.startsWith(`${ACCEPT_PATH}?`)) return null;
  const params = new URLSearchParams(raw.slice(ACCEPT_PATH.length + 1));
  const keys = [...params.keys()];
  if (keys.length !== 1 || keys[0] !== "token" || !params.get("token")) {
    return null;
  }
  return raw;
}
